{
  "page": {
    "title": "Shipment Tracking",
    "subtitle": "Track active shipments, handle RTS, and retry tracking errors.",
    "tabsAria": "Shipment tabs",
    "panelAria": "{{tab}} panel",
    "loadFailed": "Failed to load the shipments list."
  },
  "common": {
    "networkError": "Network error - check connection",
    "loading": "Loading shipments..."
  },
  "tabLabels": {
    "in_transit": "In Transit",
    "rts": "RTS Queue",
    "errors": "Tracking Errors"
  },
  "filters": {
    "ariaLabel": "Shipment filters",
    "carrier": "Carrier",
    "carrierAll": "— All —",
    "search": "Search (order # or tracking #)",
    "searchPlaceholder": "PWO… or tracking number",
    "vendorId": "Vendor ID",
    "dateFrom": "From date",
    "dateTo": "To date",
    "apply": "Apply",
    "reset": "Clear filters",
    "reload": "Reload",
    "validation": {
      "invalidDate": "Enter a valid date and time.",
      "dateRange": "From date must be on or before to date."
    }
  },
  "inTransit": {
    "loading": "Loading shipments...",
    "empty": "No shipments in transit.",
    "columns": {
      "tracking": "Tracking #",
      "carrier": "Carrier",
      "status": "Status",
      "vendor": "Vendor",
      "eta": "ETA",
      "firstScan": "First Scan",
      "delivered": "Delivered",
      "updated": "Updated",
      "order": "Order",
      "actions": "Actions"
    }
  },
  "status": {
    "stale": "Stale"
  },
  "refresh": {
    "aria": "Refresh tracking",
    "loading": "Refreshing tracking…",
    "success": "Tracking refreshed",
    "terminalTooltip": "Delivery is complete — no refresh needed",
    "errors": {
      "noPerm": "You don't have permission to refresh tracking",
      "notFound": "Package not found",
      "quotaExceeded": "Tracking refresh limit reached — try again later",
      "carrierDown": "Carrier is temporarily unavailable — try again later",
      "generic": "Could not refresh tracking"
    }
  },
  "rtsQueue": {
    "loading": "Loading RTS queue...",
    "empty": "No orders in the RTS queue.",
    "columns": {
      "order": "Order",
      "merchant": "Merchant",
      "vendor": "Vendor",
      "returnReason": "Return reason",
      "returnedAt": "Returned at",
      "actions": "Actions"
    },
    "actions": {
      "shipAgain": "Ship again",
      "refund": "Refund",
      "openTicket": "Open ticket",
      "unavailable": "Not available yet — refunds and re-shipments are not processed automatically. Handle this return manually."
    }
  },
  "trackingErrors": {
    "loading": "Loading tracking errors...",
    "empty": "No orders with tracking errors.",
    "columns": {
      "order": "Order",
      "tracking": "Tracking #",
      "carrier": "Carrier",
      "lastFetch": "Last fetch",
      "failures": "Failures",
      "error": "Error",
      "actions": "Actions"
    },
    "retry": "Retry",
    "retrying": "Retrying...",
    "toast": {
      "notAccepted": "Retry request not accepted",
      "queuedTitle": "Retry queued",
      "queuedDesc": "Order {{orderNumber}} → carrier will retry."
    }
  },
  "shipAgain": {
    "dialogAria": "Ship again to new address",
    "title": "Ship again — order {{orderNumber}}",
    "description": "Enter a new address. The shipping fee is debited from the merchant wallet. The vendor will create a new fulfillment.",
    "fields": {
      "fullName": "Recipient full name *",
      "line1": "Address line 1 *",
      "line2": "Address line 2",
      "city": "City *",
      "state": "State / Province",
      "postalCode": "Postal code *",
      "country": "Country (ISO-2) *",
      "phone": "Phone number",
      "note": "Note"
    },
    "cancel": "Cancel",
    "submit": "Ship again",
    "submitting": "Submitting...",
    "toast": {
      "notAccepted": "Ship-again request not accepted",
      "queuedTitle": "Ship-again queued",
      "queuedDesc": "Order {{orderNumber}} → new fulfillment in queue."
    }
  },
  "refund": {
    "dialogAria": "Refund order",
    "title": "Refund — order {{orderNumber}}",
    "description": "Refund to the merchant wallet. You can optionally compensate the vendor from the platform wallet.",
    "fields": {
      "amount": "Refund amount (USD) *",
      "reason": "Reason *",
      "justification": "Justification * (at least 10 characters)",
      "vendorComp": "Vendor compensation (USD, optional)"
    },
    "reasons": {
      "SHIPPING_LOST": "Shipment lost / missing",
      "CUSTOMER_DISSATISFACTION": "Customer dissatisfaction",
      "QUALITY_DEFECT": "Quality defect",
      "WRONG_ADDRESS": "Wrong address",
      "CARRIER_RETURN": "Carrier return",
      "OTHER": "Other"
    },
    "validation": {
      "amountInvalid": "Amount must be greater than 0.",
      "justificationTooShort": "Justification must be at least 10 characters."
    },
    "cancel": "Cancel",
    "submit": "Refund",
    "submitting": "Submitting...",
    "toast": {
      "notAccepted": "Refund request not accepted",
      "queuedTitle": "Refund queued",
      "queuedDesc": "Order {{orderNumber}} → refund {{amount}}."
    }
  },
  "openTicket": {
    "dialogAria": "Open support ticket",
    "title": "Open ticket — order {{orderNumber}}",
    "description": "Create a support ticket linked to this order. The merchant will be notified.",
    "fields": {
      "subject": "Subject (optional)",
      "body": "Body *",
      "priority": "Priority *",
      "category": "Category *"
    },
    "priorities": {
      "LOW": "Low",
      "NORMAL": "Normal",
      "HIGH": "High",
      "URGENT": "Urgent"
    },
    "validation": {
      "bodyRequired": "Ticket body is required."
    },
    "cancel": "Cancel",
    "submit": "Open ticket",
    "submitting": "Submitting...",
    "toast": {
      "notAccepted": "Open-ticket request not accepted",
      "queuedTitle": "Ticket queued",
      "queuedDesc": "Order {{orderNumber}} → ticket with {{priority}} priority."
    }
  },
  "_vgBinding": "vg-binding: P4.11.D-29,P4.11.D-30,P4.11.D-31,P4.11.D-32 — i18n keys for In Transit First Scan/Delivered/Actions columns + stale badge label (status.stale, enum VALUE stays English) across en/vi/fr [task-18]"
}
